import { defineComponent as i, inject as s, computed as u, createBlock as p, openBlock as f, unref as z, withCtx as d, renderSlot as g } from "vue";
import { COMPONENT_NAME as y } from "./highrise178.mjs";
import x, { spaceProps as h } from "./highrise623.mjs";
const v = i({
  name: y.SPACE,
  inheritAttrs: !1
}), A = /* @__PURE__ */ i({
  ...v,
  props: {
    ...h,
    size: {
      type: [String, Number, Array],
      default: "sm"
    },
    wrapItem: {
      type: Boolean,
      default: !1
    }
  },
  setup(o) {
    const e = o, a = (r) => typeof r == "number" || Array.isArray(r) ? r : {
      lg: 16,
      md: 12,
      sm: 8,
      xs: 4,
      "2xs": 2,
      "3xs": 1
    }[r] ?? 8, n = s("hr-radio-group-size", "sm"), l = s("hr-checkbox-group-size", "sm"), c = s("hr-toggle-group-size", "sm"), m = u(() => {
      const r = e.size || n || l || c;
      if (typeof r == "number")
        return r;
      if (r) {
        const t = {
          lg: 12,
          md: 12,
          sm: 8,
          xs: 8,
          "2xs": 8,
          "3xs": 8
        };
        return e != null && e.vertical ? 8 : t[r];
      }
      return a(e.size);
    });
    return (r, t) => (f(), p(z(x), {
      class: "hr-space-inner",
      size: m.value,
      align: e.align,
      justify: e.justify,
      inline: e.inline,
      vertical: e.vertical,
      reverse: e.reverse,
      "wrap-item": e.wrapItem,
      "item-class": e.itemClass,
      "item-style": e.itemStyle,
      wrap: e.wrap
    }, {
      default: d(() => [
        g(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["size", "align", "justify", "inline", "vertical", "reverse", "wrap-item", "item-class", "item-style", "wrap"]));
  }
});
export {
  A as default
};
